export default "__VITE_ASSET__DPAT12sI__"